module.exports = __webpack_public_path__ + "img/treasurybg.d406e889.jpg";